import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { actionCreators } from './store';
import { Checkbox, message } from 'antd';
import imgLoginLogo from '../../../assets/images/loginlogo.png';
import Footer from '../../../common/footer';
import './style.css';

class Forget extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			isChangePassType: false,
			isChangeRPassType: false,
			agreeChecked: false,
			isOpenAgreeModel: false,
		};
		this.togglePassInputType = this.togglePassInputType.bind(this);
		this.toggleRPassInputType = this.toggleRPassInputType.bind(this);
		this.toggleAgreeChecked = this.toggleAgreeChecked.bind(this);
		this.toggleAgreeModel = this.toggleAgreeModel.bind(this);
	}
	
	//切换密码框的类型
	togglePassInputType(el){
		if(el.type === 'text'){
			this.setState({
				isChangePassType: false
			})
			el.type = 'password'
		}else{
			this.setState({
				isChangePassType: true
			})
			el.type = 'text'
		}
	}
	
	//切换重复密码框的类型
	toggleRPassInputType(el){
		if(el.type === 'text'){
			this.setState({
				isChangeRPassType: false
			})
			el.type = 'password'
		}else{
			this.setState({
				isChangeRPassType: true
			})
			el.type = 'text'
		}
	}
	
	toggleAgreeChecked(){
    this.setState({ agreeChecked: !this.state.agreeChecked });
  };
	toggleAgreeModel(){
		this.setState({ isOpenAgreeModel: !this.state.isOpenAgreeModel });
	}
	componentDidMount() {
		this.props.editCaptcha();
	}
	
	render() {
		const { userName, errUserName, isUserName, userTel, isUserTel, errUserTel, userPass, isUserPass, errUserPass, userRPass, isUserRPass, errUserRPass, phoneYzm, 
			isErrorPhoneYzm, errPhoneYzm, captcha, phonePyzm, isErrorPhonePyzm, errPhonePyzm, sendYzmText, isSendYzmText, sending, getSign, countdown, isManuBtnClick,
			validateUserTel, validateUserPass, validateUserRPass, validateUserYzm, validateUserPYzm, handleUserNameChange, validateUserName, handleUserTelChange, 
			handlePassChange, handleRPassChange, handleYzmChange, handlePYzmChange, editCaptcha,getsigncode, registerf, handleEnterKey } = this.props;
		return(
			<div className="lrregister">
				<header>
					<div className="headerin mx1200 mauto clear posr">
						<img src={imgLoginLogo} className="fl m30t" alt=""/>
						<div className="size_18 posa">
							<span className="c_666">已有大立教育账号了?</span>
							<Link to="/login" className="c_blue cursp">
								立即登录
							</Link>
						</div>
					</div>
				</header>
				<div className="main">
					<div className="mainin mx1200 mauto posr">
						<div className="con posa">
							<div className="top textc">
								注册账号
							</div>
							<div className="down">
							<div className={isUserName ? 'item username errorcon' : 'item username'}>
								<input type="text" value={userName} ref={node => this.userNameEl = node}
									onChange={ev => handleUserNameChange(ev)}
									placeholder="请输入用户名" 
									onBlur={ev => validateUserName(ev)}/>
								{isUserName ? (
									<div className="error">{errUserName}</div>
								) : null}
							</div>
								<div className={isUserTel ? 'item tel errorcon' : 'item tel'}>
									<input type="text" value={userTel}  ref={node => this.userTelEl = node}
										placeholder="请输入手机号" onChange={ev => handleUserTelChange(ev)}
										onBlur={ev => validateUserTel(ev)}/>
									{isUserTel ? (
										<div className="error">{errUserTel}</div>
									) : null}
								</div>
								<div className={isUserPass ? 'item pass errorcon' : 'item pass'}>
									<input type="password"  value={userPass} ref={node => this.passEl = node}
										placeholder="请输入新密码" onChange={ev => handlePassChange(ev)}
										onBlur={ev => validateUserPass(ev, userRPass)}/>
									{isUserPass ? (
										<div className="error">{errUserPass}</div>
									) : null}
									<div className={this.state.isChangePassType ? 'img imgopen' : 'img'}
										onClick={ev =>　this.togglePassInputType(this.passEl)}></div>
								</div>
								<div className={isUserRPass ? 'item pass errorcon' : 'item pass'}>
									<input type="password" value={userRPass} ref={node => this.rpassEl = node}
										placeholder="请再次输入新密码" onChange={ev => handleRPassChange(ev)}
										onBlur={ev =>　validateUserRPass(ev, userPass)}/>
									{isUserRPass ? (
										<div className="error">{errUserRPass}</div>
									) : null}
									<div className={this.state.isChangeRPassType ? 'img imgopen' : 'img'}
										onClick={ev =>　this.toggleRPassInputType(this.rpassEl)}></div>
								</div>
								<div className={isErrorPhoneYzm ? 'item yzm clear errorcon' : 'item yzm clear'}>
									<input type="text" maxLength="4" value={phoneYzm}  ref={node => this.phoneYzmEl = node}
										placeholder="请输入图形验证码" onChange={ev => handleYzmChange(ev)}
										onBlur={ev => validateUserYzm(ev)}/>
									<img className="cursp" onClick={ev => editCaptcha()} src={captcha} alt="验证码"/>
									{isErrorPhoneYzm ? (
										<div className="error">{errPhoneYzm}</div>
									) : null}
								</div>
								<div className={isErrorPhonePyzm ? 'item pyzm clear errorcon' : 'item pyzm clear'}>
									<input type="text" maxLength="6" value={phonePyzm}  ref={node => this.phonePyzmEl = node}
										placeholder="请输入短信验证码" onChange={ev => handlePYzmChange(ev)}
										onKeyPress={ev => handleEnterKey(ev, registerf, this.userNameEl, this.userTelEl, this.passEl, this.rpassEl, this.phoneYzmEl, this.phonePyzmEl, isUserName, isUserTel, isUserPass, isUserRPass, isErrorPhoneYzm, isErrorPhonePyzm, getSign, this.state.agreeChecked)}
										onBlur={ev => validateUserPYzm(ev)}
										/>
									{!isSendYzmText && !sending ? (
										<span className="bluebdbtn" onClick={ev => getsigncode(this.userTelEl, isUserTel, countdown)}>{sendYzmText}</span>
									) : null}
									{(!isSendYzmText && sending) || (isSendYzmText && sending) ? (
										<span className="graybtn">{sendYzmText}</span>
									) : null}
									{isErrorPhonePyzm ? (
										<div className="error">{errPhonePyzm}</div>
									) : null}
								</div>
								<div className="item agree">
									<Checkbox
										checked={this.state.agreeChecked}
										onChange={this.toggleAgreeChecked}
									>
										我已阅读并同意
									</Checkbox>
									<span className="m34lm c_blue cursp" onClick={this.toggleAgreeModel}>《大立教育服务协议》</span>
								</div>
								<div className="item sbbtn">
									{isManuBtnClick ? (
										<button type="button" className="opacity8">注册中，请稍后...</button>
									) : (
										<button onClick={ev => registerf(this.userNameEl, this.userTelEl, this.passEl, this.rpassEl, this.phoneYzmEl, this.phonePyzmEl, isUserName, isUserTel, isUserPass, isUserRPass, isErrorPhoneYzm, isErrorPhonePyzm, getSign, this.state.agreeChecked)} type="button" className="cursp">注册</button>
									)}
								</div>
								<div className="item btext clear">
									<Link to="/login" className="c_333 fr">
										已有账号？立即登录
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* 服务协议model start */}
				{this.state.isOpenAgreeModel ? (
					<div className="commodel">
						<div className="commodelin">
							<div className="title">大立教育服务协议
								<div className="close"onClick={this.toggleAgreeModel}></div>
							</div>
							<div className="con">
								<ul>
									<li>
										<div className="bigtitle font_m c_blue lineht24">一、服务条款的确认和接纳</div>
										<div className="conin c_666 lineht24">
											<div>本站网校的各项电子服务的所有权和运作权归属北京大立立德教育科技有限公司。用户必须完全同意以下所有服务条款才能成为本站网校网络课堂的正式用户。</div>
										</div>
									</li>
									<li>
										<div className="bigtitle font_m c_blue lineht24">二、用户的权利和义务</div>
										<div className="smalltitle lineht24 c_blue">1.所有用户必须遵循：</div>
										<div className="conin c_666 lineht24">
											<div>- 遵守所有使用网络服务的网络协议、规定、程序和惯例；</div>
											<div>- 不得使用本网站从事违法活动；</div>
											<div>- 不得干扰或侵犯本网站的正常运行和其他用户的正常使用；</div>
											<div>- 从中国境内向境外传输技术性资料时不得违反中国有关法律、法规。</div>
										</div>
										<div className="smalltitle lineht24 c_blue">2.同时用户承诺：</div>
										<div className="conin c_666 lineht24">
											<div>- 不得传输任何非法的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、淫秽的信息资料；</div>
											<div>- 不得传输任何教唆他人进行违法犯罪行为的资料； </div>
											<div>- 不得传输不利于国内团结和社会安定的资料； </div>
											<div>- 不得传输任何不符合国家法律、法规规定的资料、信息； </div>
											<div>- 不得未经许可而非法进入其它个人或组织电脑系统； </div>
											<div>- 法律规定的其他义务。 </div>
										</div>
										<div className="conin c_666 lineht24">
											<div>如果用户的行为违背上述两款规定，本站网校可以做出独立判断并有权立即取消用户资格。用户应对自己在网上的违法行为承担全部法律责任。</div>
										</div>
										<div className="smalltitle lineht24 c_blue">3.基于网络服务的特殊性，用户同意：</div>
										<div className="conin c_666 lineht24">
											<div>- 在注册时按照注册提示提供准确用户名和密码以及详尽的个人资料； </div>
											<div>- 在个人的注册信息发生变化时，用户应及时更新自己的注册信息，保证其个人资料的详尽和准确。所有用户输入的个人信息将被视作准确表明了用户的身份，并作为本网站提供所有服务的有效身份依据。 </div>
											<div>- 用户自行配备上网的所需设备，包括个人电脑、调制解调器或其他必备上网装置；</div>
											<div>- 用户应自行负担因使用这种接入方式而产生的电话费、上网费。</div>
										</div>
										<div className="smalltitle lineht24 c_blue">4.用户的用户名、密码：</div>
										<div className="conin c_666 lineht24">
											<div>- 用户一旦注册成功，成为本站网校网络课堂的正式用户后，应当对自己的用户名、密码的安全性负全部责任。用户的密码只能由用户自己掌握； </div>
											<div>- 对于用户因帐号或密码泄露造成的各种损失，本站网校不承担任何责任。用户发现任何非法使用用户帐号的情况，应立即通知本站网校；</div>
											<div>- 用户应对以其用户名进行的所有活动和事件负责，不得允许多人使用同一账户学习，一经发现立即关闭其课堂，并不退还学费；</div>
											<div>- 用户付费后网络课堂一旦开通，不允许退学、换课。</div>
										</div>
										<div className="smalltitle lineht24 c_blue">5.关于学习卡用户：</div>
										<div className="conin c_666 lineht24">
											<div>- 如需要本站网校学习卡，请通过正规渠道到全国各地指定的经销点购买，通过非正规渠道获取的学习卡，网校发现后将予以封除，同时依法追究其相关责任； </div>
											<div>- 用户购买学习卡后，请保存好原始卡片，或保留从正规渠道获取本站网校学习帐号的证据、证明，对无原始卡片或无法证明从正规渠道购买课程的学习帐号，一旦发现问题，我们将概不负责并予以封除；</div>
											<div>- 对于合资共用帐户的行为，一经发现，网校坚决进行封除帐户，同时追究相关人员的法律责任；</div>
											<div>- 本服务条款其他内容同样适用于学习卡用户。</div>
										</div>
										<div className="smalltitle lineht24 c_blue">6.网络课堂学习期限：</div>
										<div className="conin c_666 lineht24">
											<div>- 本站网校的网络课程自上传完备后，学员可以在任何时间点、任何地点进行反复学习。可以自行安排学习时间和学习进度。(课件下载次数不能超过10次)； </div>
											<div>- 本站网校网络教育考试学习从报名开课起至该年度最近一次考试结束，考试后网络课堂将关闭，学员将不能再登录课堂学习。 </div>
										</div>
									</li>
									<li>
										<div className="bigtitle font_m c_blue lineht24">三、本站网校的权利和义务</div>
										<div className="conin c_666 lineht24">
											<div>1.本站网校应本着诚实信用的原则向用户提供远程教育服务，不得随意中断或停止提供该项服务。但由于不可抗力或者意外事件造成的服务的中断或停止，本站网校不承担任何相应的责任。</div>
											<div>2.本站网校网站内以任何形式表现的作品（包括但不限于文字、软件、声音、图片、录像、表格、电子邮件等）的著作权，由作品的著作权人和北京大立立德教育科技有限公司共同享有，用户未经许可，不得擅自对本网站的包括电子课件在内的任何作品进行任何形式的翻录、复制或从事其他任何违反著作权法等相关法律、法规的活动。对侵犯本网站知识产权的个人和组织，北京大立立德教育科技有限公司和作品的著作权人将依法追究其民事或刑事责任。课堂中的学习内容（课件声音、讲义文本、习题及答案）用户下载后仅只能做为自己学习之用，不得转发给他人共享使用或进行销售，一经发现用户有此行为立即关闭其课堂(不退还学费)并追究其法律责任。 </div>
											<div>3.本网站享有对用户网上活动的监督和指导权，对凡是从事网上非法活动的用户，有权终止所有服务。</div>
										</div>
									</li>
									<li>
										<div className="bigtitle font_m c_blue lineht24">四、保密责任</div>
										<div className="smalltitle lineht24">本网站将严格履行用户个人隐私保密义务，承诺不公开或透露用户个人信息，但以下情况除外：</div>
										<div className="conin c_666 lineht24">
											<div>- 用户授权本站网校公开这些信息；</div>
											<div>- 相应的法律及法律程序要求本站网校提供用户的个人资料； </div>
											<div>- 紧急情况下，需竭力维护用户个人、其他社会个体和社会大众的安全。 </div>
										</div>
									</li>
									<li>
										<div className="bigtitle font_m c_blue lineht24">五、服务条款的修改和完善</div>
										<div className="conin c_666 lineht24">
											<div>1.本站网校将根据互连网的发展和法律、法规的变化，在认为必要时可以单方面修改服务条款。</div>
											<div>2.本服务条款一旦发生变动，将会在重要页面上提示修改内容。如果不同意所改动的内容， 用户可以主动放弃获得的网络服务。如果用户继续享用网络服务，则视为接受服务条款的变动。当发生争执时，以最新服务条款的内容为准。  </div>
										</div>
									</li>
									<li>
										<div className="conin c_666 lineht24">
											<div>（北京大立立德教育科技有限公司拥有以上内容最终解释权！）</div>
										</div>
									</li>
								</ul>
							</div>
							<div className="button" onClick={this.toggleAgreeModel}>
								我知道了
							</div>
						</div>
					</div>
				) : null}
				{/* 服务协议model  end */}
				<Footer/>
			</div>
		)
	}
}


const mapStateToProps = (state) => {
	return {
		userName: state.getIn(['register', 'userName']),
		isUserName: state.getIn(['register', 'isUserName']),
		errUserName: state.getIn(['register', 'errUserName']),
		userTel: state.getIn(['register', 'userTel']),
		isUserTel: state.getIn(['register', 'isUserTel']),
		errUserTel: state.getIn(['register', 'errUserTel']),
		userPass: state.getIn(['register', 'userPass']),
		isUserPass: state.getIn(['register', 'isUserPass']),
		errUserPass: state.getIn(['register', 'errUserPass']),
		userRPass: state.getIn(['register', 'userRPass']),
		isUserRPass: state.getIn(['register', 'isUserRPass']),
		errUserRPass: state.getIn(['register', 'errUserRPass']),
		phoneYzm: state.getIn(['register', 'phoneYzm']),
		isErrorPhoneYzm: state.getIn(['register', 'isErrorPhoneYzm']),
		errPhoneYzm: state.getIn(['register', 'errPhoneYzm']),
		phonePyzm: state.getIn(['register', 'phonePyzm']),
		isErrorPhonePyzm: state.getIn(['register', 'isErrorPhonePyzm']),
		errPhonePyzm: state.getIn(['register', 'errPhonePyzm']),
		captcha: state.getIn(['register', 'captcha']),
		sendYzmText: state.getIn(['register', 'sendYzmText']),
		isSendYzmText: state.getIn(['register', 'isSendYzmText']),
		sending: state.getIn(['register', 'sending']),
		getSign: state.getIn(['register', 'getSign']),
		countdown: state.getIn(['register', 'countdown']),
		isManuBtnClick: state.getIn(['register', 'isManuBtnClick']),
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		handleUserNameChange(e){
			let val = e.target.value;
			dispatch(actionCreators.handleUserNameChange(val));
			dispatch(actionCreators.toggleUserNameErr(false, ''));
		},
		handleUserTelChange(e) {
			let val = e.target.value;
			dispatch(actionCreators.handleUserTelChange(val));
			dispatch(actionCreators.toggleUserTelErr(false, ''));
		},
		handlePassChange(e){
			let val = e.target.value;
			dispatch(actionCreators.handlePassChange(val));
			dispatch(actionCreators.togglePassErr(false, ''));
		},
		handleRPassChange(e){
			let val = e.target.value;
			dispatch(actionCreators.handleRPassChange(val));
			dispatch(actionCreators.toggleRPassErr(false, ''));
		},
		handleYzmChange(e){
			let val = e.target.value;
			dispatch(actionCreators.handleYzmChange(val));
			dispatch(actionCreators.toggleYzmErr(false, ''));
		},
		handlePYzmChange(e){
			let val = e.target.value;
			dispatch(actionCreators.handlePYzmChange(val));
			dispatch(actionCreators.togglePYzmErr(false, ''));
		},
		validateUserName(e) {
			let val = e.target.value;
			if(val === ''){
				dispatch(actionCreators.toggleUserNameErr(true, '您还没有输入用户名'));
				return false;
			}else if(3 > val.length || val.length > 20){
				dispatch(actionCreators.toggleUserNameErr(true, '长度为3到20个字符'));
				return false;
			}
			dispatch(actionCreators.validateUserName(val));
		},
		validateUserTel(e){
			let val = e.target.value;
			if(val === ''){
				dispatch(actionCreators.toggleUserTelErr(true, '您还没有输入手机号'));
				return false;
			}else if(!(/^(13[0-9]|14[579]|15[0-3,5-9]|16[5,6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(val))){
				dispatch(actionCreators.toggleUserTelErr(true, '手机格式不正确'));
				return false;
			}
			dispatch(actionCreators.validateUserTel(val));
		},
		validateUserPass(e, passr){
			let val = e.target.value;
			if(val === ''){
				dispatch(actionCreators.togglePassErr(true, '您还没有输入新密码'));
				return false;
			}else if (val.length < 6){
				dispatch(actionCreators.togglePassErr(true, '密码不少于六位，字母、数字都可'));
				return false;
			}else if(passr !== '' && val !== passr){
				dispatch(actionCreators.togglePassErr(true, '两次密码输入不一致'));
				return false;
			}else{
				dispatch(actionCreators.togglePassErr(false, ''));
				return false;
			}
		},
		validateUserRPass(e, pass){
			let val = e.target.value;
			if(val === ''){
				dispatch(actionCreators.toggleRPassErr(true, '您还没有输入确认密码'));
				return false;
			}else if (val.length < 6){
				dispatch(actionCreators.toggleRPassErr(true, '密码不少于六位，字母、数字都可'));
				return false;
			}else if (val !== pass){
				dispatch(actionCreators.toggleRPassErr(true, '两次密码输入不一致'));
				return false;
			}else{
				dispatch(actionCreators.toggleRPassErr(false, ''));
				return false;
			}
		},
		validateUserYzm(e){
			let val = e.target.value;
			if(val === ''){
				dispatch(actionCreators.toggleYzmErr(true, '您还没有输入图形验证码'));
				return false;
			}else if(val.length !== 4){
				dispatch(actionCreators.toggleYzmErr(true, '图形验证码长度为4位'));
				return false;
			}
			dispatch(actionCreators.validateUserYzm(val));
		},
		validateUserPYzm(e){
			let val = e.target.value;
			if(val === ''){
				dispatch(actionCreators.togglePYzmErr(true, '您还没有短信验证码'));
				return false;
			}else{
				dispatch(actionCreators.togglePYzmErr(false, ''));
				return false;
			}
		},
		editCaptcha(){
			dispatch(actionCreators.editCaptcha());
		},
		getsigncode(userTelEl, isUserTel, countdown) {
			let userTel = userTelEl.value;
			if(userTel === ''){
				dispatch(actionCreators.toggleUserTelErr(true, '您还没有输入手机号.'));
				userTelEl.focus();
				return false;
			}else if(!(/^(13[0-9]|14[579]|15[0-3,5-9]|16[5,6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(userTel))){
				dispatch(actionCreators.toggleUserTelErr(true, '手机格式不正确.'));
				userTelEl.focus();
				return false;
			}
			if(isUserTel){
				userTelEl.focus();
				return false;
			}
			dispatch(actionCreators.getsigncode(userTel, countdown));
		},
		registerf(userNameEl, userTelEl, passEl, rpassEl, phoneYzmEl, phonePyzmEl, isUserName, isUserTel, isUserPass, isUserRPass, isErrorPhoneYzm, isErrorPhonePyzm, getSign, isAgree){
			let userName = userNameEl.value;
			let userTel = userTelEl.value;
			let pass = passEl.value;
			let rpass = rpassEl.value;
			let phoneYzm = phoneYzmEl.value;
			let phonePyzm = phonePyzmEl.value;
			if(!isAgree){
				message.error('请先勾选并阅读大立教育服务协议哦！');
				return false;
			}
			if(userName === ''){
				dispatch(actionCreators.toggleUserNameErr(true, '您还没有输入用户名'));
				return false;
			}else if(3 > userName.length || userName.length > 20){
				dispatch(actionCreators.toggleUserNameErr(true, '长度为3到20个字符'));
				return false;
			}else if(userTel === ''){
				dispatch(actionCreators.toggleUserTelErr(true, '您还没有输入手机号'));
				return false;
			}else if(!(/^(13[0-9]|14[579]|15[0-3,5-9]|16[5,6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(userTel))){
				dispatch(actionCreators.toggleUserTelErr(true, '手机格式不正确'));
				return false;
			}else if(pass === ''){
				dispatch(actionCreators.togglePassErr(true, '您还没有输入新密码'));
				return false;
			}else if (pass.length < 6){
				dispatch(actionCreators.togglePassErr(true, '密码不少于六位，字母、数字都可'));
				return false;
			}else if(rpass !== '' && pass !== rpass){
				dispatch(actionCreators.togglePassErr(true, '两次密码输入不一致'));
				return false;
			}else if(rpass === ''){
				dispatch(actionCreators.toggleRPassErr(true, '您还没有输入确认密码'));
				return false;
			}else if (rpass.length < 6){
				dispatch(actionCreators.toggleRPassErr(true, '密码不少于六位，字母、数字都可'));
				return false;
			}else if (rpass !== pass){
				dispatch(actionCreators.toggleRPassErr(true, '两次密码输入不一致'));
				return false;
			}else if(phoneYzm === ''){
				dispatch(actionCreators.toggleYzmErr(true, '您还没有输入图形验证码'));
				return false;
			}else if(phoneYzm.length !== 4){
				dispatch(actionCreators.toggleYzmErr(true, '图形验证码长度为4位'));
				return false;
			}else if(phonePyzm === ''){
				dispatch(actionCreators.togglePYzmErr(true, '您还没有短信验证码'));
				return false;
			}
			if(isUserName){
				userNameEl.focus();
				return false;
			}else if(isUserTel){
				userTelEl.focus();
				return false;
			}else if(isUserPass){
				passEl.focus();
				return false;
			}else if(isUserRPass){
				rpassEl.focus();
				return false;
			}else if(isErrorPhoneYzm){
				phoneYzmEl.focus();
				return false;
			}else if(isErrorPhonePyzm){
				phonePyzmEl.focus();
				return false;
			}
			dispatch(actionCreators.registerf(userName, userTel, pass, phoneYzm, phonePyzm, getSign));
		},
		handleEnterKey(e, registerf, userNameEl, userTelEl, passEl, rpassEl, phoneYzmEl, phonePyzmEl, isUserName, isUserTel, isUserPass, isUserRPass, isErrorPhoneYzm, isErrorPhonePyzm, getSign, isAgree){
			if(e.nativeEvent.keyCode === 13){
				registerf(userNameEl, userTelEl, passEl, rpassEl, phoneYzmEl, phonePyzmEl, isUserName, isUserTel, isUserPass, isUserRPass, isErrorPhoneYzm, isErrorPhonePyzm, getSign, isAgree);
			}
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Forget);

